// HazardsPanel/index.js
import { connect } from 'react-redux';
import HazardsPanel from '../../components/HazardsPanel';

import {
  searchTermChangeForAllHazards,
  openCreateHazardDialogDispatch,
  changeHazardStatusTypeFilter,
  changeHazardDescriptionSortTypeFilter
} from '../../actions';
function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.hazard.newHazard.showEditHazardDialog,
    openPanel: state.hazard.newHazard.showEditHazardPanel,
    searchTerm: state.hazards.hazardsByBranch.searchTerm,
    openHazardReviewPanel: state.hazard.newHazard.showHazardReviewPanel,
    openHazardLogsPanel: state.hazard.newHazard.showHazardManagementLogPanel,
    selectedStausFilter: state.hazards.hazardStatusFilter.filter,
    selectedSortFilter: state.hazards.hazardDescriptionFilter.filter,
    statusFilters: state.hazards.hazardStatusFilter.items,
    descriptionFilters: state.hazards.hazardDescriptionFilter.items
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    handleSearchTermChange: (searchTerm) => {
      dispatch(searchTermChangeForAllHazards(searchTerm));
    },
    openCreateAccidentDialog: (open) => {
      dispatch(openCreateHazardDialogDispatch(open));
    },
    onHazardStatsTypeFilterChange: (stausId) => {
      dispatch(changeHazardStatusTypeFilter(stausId));
    },
    onHazardSortTypeFilterChange: (sortId) => {
      dispatch(changeHazardDescriptionSortTypeFilter(sortId));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HazardsPanel);
